
export default function Results() {
  const metrics = [
    {
      stat: '+38%',
      description: 'Increase in Booked Appointments'
    },
    {
      stat: '-72%',
      description: 'Missed Call Rate'
    },
    {
      stat: '24/7',
      description: 'Automated Intake Coverage'
    }
  ];

  return (
    <section className="relative bg-[#F8FAFC] py-28 lg:py-36 overflow-hidden">
      {/* Background visual */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b76f9a893ea29f56cb8c055d056f855f.jpg"
          alt="Background"
          className="w-full h-full object-cover object-top opacity-30"
        />
      </div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="text-center mb-20">
          <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[#2563EB] mb-4">Performance</p>
          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-[#0B1C2D] tracking-tight">
            Forward Trajectory.
            <br />
            Measurable Lift.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {metrics.map((metric, index) => (
            <div key={index} className="text-center bg-white rounded-2xl p-10 shadow-sm">
              <div className="text-5xl lg:text-6xl xl:text-7xl font-bold text-[#2563EB] mb-4 tracking-tight">
                {metric.stat}
              </div>
              <div className="w-12 h-0.5 bg-[#2563EB]/20 mx-auto mb-4" />
              <p className="text-base lg:text-lg text-[#0B1C2D] font-semibold leading-relaxed">
                {metric.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
